import { createSlice, PayloadAction } from '@reduxjs/toolkit';


interface MenuAuthority {
    menuLevel: number;
    menuCode: string;
    menuUrl: string;
    menuName: string;
    upperMenuCode: string;
    readAuthorityYn: string;
    writeAuthorityYn: string;
    menuOrder: number;
}

interface MenuAuthMap {
    [key: string]: MenuAuthority;
}

interface AuthState {
    authorityId: string;
    firstUrl: string;
    MENUAUTH: MenuAuthMap;
}

interface AuthSliceState {
    value: AuthState;
}

const initialState: AuthSliceState = {
    value: {
        authorityId: "",
        firstUrl: "",
        MENUAUTH: {}
    }
};

export const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        loginAuth: (state, action: PayloadAction<AuthState>) => {
            state.value = action.payload;
        },
    },
});

export const { loginAuth } = authSlice.actions;

export default authSlice.reducer;

// RootState 타입을 위한 export
export type { AuthState, MenuAuthority, MenuAuthMap };